module.exports = __webpack_public_path__ + "img/image19-1.502ce19d.png";